import React from 'react';
import services from '../data/services';
import Icons from './Icons';

export default function Services() {
	return (
		<section id="servicios" className="py-12 bg-white">
			<div className="max-w-7xl mx-auto px-4">
				<h2 className="text-3xl font-bold mb-6">Servicios Especializados</h2>
				<div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
					{services.map(s => (
						<div key={s.id} className="bg-white rounded-lg border p-4 shadow-sm">
							<div className="h-36 mb-3 bg-slate-100 rounded-md overflow-hidden">
								<img src={s.image} alt={s.title} className="w-full h-full object-cover" />
							</div>
							<h3 className="font-bold mb-2">{s.title}</h3>
							<p className="text-sm text-slate-600">{s.description}</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
